import React from 'react';
import './LoadingMeeting.css';

const LoadingMeeting = () => (
  <div className="LoadingMeeting">
    <p>
      Loading
    </p>
  </div>
);

export default LoadingMeeting;



// WEBPACK FOOTER //
// ./src/components/meeting/LoadingMeeting.jsx